<div class="shimmer">
  <div style="width: 500px; height: 100px"></div>
</div>
